
import MUISwitch from "../Gauges/MUISwitch"
import Stack from '@mui/material/Stack';
import { useState } from "react";
import { Card, Box, Typography } from "@mui/material";
import Funnel from "./Funnel";
import MUISwitchFunnel from "./MUISwitchFunnel";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../../../../cssfiles/homepage.css';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useSelector,useDispatch } from "react-redux";
import { setOptions } from "leaflet";

export default function SwitchFunnel(props){
    //// console.log("IN SwitchFunnel I AM IN");
    
    const [energyconsumersaver, setEnergyconsumersaver] = useState(true);
    const [stateVarConsumerSaver, setStateVarConsumerSaver] = useState(true);
    const [dropdownoption, setDropdownoption] = useState('Asset')
    const theme = useSelector((state) => state.themedata.theme)

    const  datavalues = ["Device-Wise","Department-Wise"];

    const [selectedValue, setSelectedValue] = useState("option1"); 
    const [selectedValueOption, setSelectedValueOption] = useState('Device-Wise'); 
    const [label, setLabel] = useState('Device-Wise'); 
    const handleChange = (event) => { 
        setSelectedValueOption(event.target.value);
       // // console.log("funnel--event.target.value",event.target.value)
        if(event.target.value=='Device-Wise'){
            setSelectedValue("option1"); 
        }else if(event.target.value=='Department-Wise'){
            setSelectedValue("option2"); 
        }
        setLabel('');
    }

    const themedIcon = <KeyboardArrowDownIcon sx={{color:(theme=='light')?"#000000":"#FFFFFF"}}/>;
     
    return(
        <>
            {/*// console.log("energyconsumersaver",energyconsumersaver)*/}
            <Stack direction="row" spacing={1} alignItems="center" sx={{marginLeft:"17px",marginTop:"20px"}}>
                {/* <Typography sx={{fontSize:'12px',fontFamily:'Roboto',fontWeight:400,color:energyconsumersaver?'#5B6E7A':'#3A4452'}}>Saved</Typography> */}
                <MUISwitchFunnel checkedA={energyconsumersaver} energyconsumersaver={energyconsumersaver} setStateVarConsumerSaver={setEnergyconsumersaver} widgetprop={props.widgetprop} /> 
                {/*  <Typography sx={{fontSize:'12px',fontFamily:'Roboto',fontWeight:400,color:energyconsumersaver?'#3A4452':'#5B6E7A'}}>Consumed</Typography> */}
                <FormControl>
                    {/*<InputLabel id="yearSelect"  shrink={false} sx={{textAlign:"left",marginRight:"6px",fontSize:'12px', fontFamily:'Roboto',fontWeight:400,marginTop:"-6px",color:"var(--GreyVariation_2)" }}>{label}</InputLabel>*/} 
                        <Select
                            //name="yearSelect" id="yearSelect" labelId="yearSelect" inputlabel="year"  
                            value={selectedValueOption} 
                            onChange={handleChange}
                            defaultValue="Device-Wise"
                            sx={{
                                width:'190px',
                                height: '40px',
                                bgcolor:'var(--SecondaryBackground)',
                                color:'var(--GreyVariation_2)',
                                fontSize:'18px',
                                fontFamily:'Roboto',
                                fontWeight:500,
                                borderBottom:(theme == 'dark')?"2px solid #FFFFFF":"2px solid #000000",
                                textAlign:'left',
                                borderRadius:0,
                                marginRight:'6px',
                                marginLeft:'100px',
                                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
                                    border:0,
                                },
                                '& .MuiOutlinedInput-notchedOutline ': {
                                    width:'190px',
                                    height:'40px',
                                    border:0,
                                    padding:0
                                },
                                '& .MuiInputLabel-root':{display:'none',legend:'none',paddingTop:"3px",paddingRight:"3px"},
                                '& .MuiSelect-icon':{ color:(theme == 'light')?"#000000":"#FFFFFF",marginLeft:"7px"}	
                            }}
                            InputLabelProps={{shrink: false}}
                            IconComponent={KeyboardArrowDownIcon}
                            MenuProps={{
                                PaperProps:{
                                    sx:{
                                        bgcolor:theme==='dark'?'#3C3C3C':'#C1C1C1',
                                        borderBottom:'2px solid #008CD7',
                                        borderTop:'2px solid #008CD7',
                                        borderRadius:0,
                                        fontSize:'18px',
                                        boxShadow:'none',
                                        maxHeight:'250px',
                                        overflow:'auto',
                                        color:theme==='dark'?'#FFFFFF':'#3C3C3C',
                                    }
                                },               
                            }}

                        >
                            {datavalues.map((period) => {
                                return <MenuItem sx={{fontSize:'16px', fontFamily:'Roboto',fontWeight:400,"& .MuiMenuItem.Mui-selected":{backgroundColor:"#005C8E"}}} value={period}>{period}</MenuItem>
                            })}
                        </Select>
                </FormControl>
            </Stack>
            <Funnel widgetprop={props.widgetprop} energyconsumersaver={energyconsumersaver} selectedValue={selectedValue}/>
        </>
    )
}